import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import CropIcon from "@mui/icons-material/Crop";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

const PREFIX = "BannerControls";

const classes = {
  footer: `${PREFIX}-footer`,
  cropButton: `${PREFIX}-cropButton`,
  deleteButton: `${PREFIX}-deleteButton`,
};

const Root = styled("div")(() => ({
  [`&.${classes.footer}`]: {
    position: "absolute",
    right: 0,
    bottom: 0,
    height: 51,
    left: 0,
    backgroundColor: "rgba(0,0,0,0.9)",
    color: "white",
  },

  [`& .${classes.cropButton}`]: {
    position: "absolute",
    right: 60,
    bottom: 1,
  },

  [`& .${classes.deleteButton}`]: {
    position: "absolute",
    right: 12,
    bottom: 1,
  },
}));

interface BannerControlsProps {
  isCropping: boolean;
  onDelete: () => void;
  onCrop: () => void;
  onCropSave: () => void;
}

export function BannerControls({
  isCropping,
  onDelete,
  onCrop,
  onCropSave,
}: BannerControlsProps) {
  const { t } = useTranslation();

  return (
    <Root className={classes.footer}>
      <Tooltip
        title={t("shared.banner.delete", { defaultValue: "Удалить" })}
        placement="top"
      >
        <IconButton
          onClick={onDelete}
          className={classes.deleteButton}
          size="large"
          color="inherit"
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      {!isCropping && (
        <Tooltip
          title={t("shared.banner.crop", { defaultValue: "Обрезать" })}
          placement="top"
        >
          <IconButton
            onClick={onCrop}
            className={classes.cropButton}
            size="large"
            color="inherit"
          >
            <CropIcon />
          </IconButton>
        </Tooltip>
      )}

      {isCropping && (
        <Tooltip
          title={t("shared.banner.saveCropped", {
            defaultValue: "Сохранить обрезку",
          })}
          placement="top"
        >
          <IconButton
            onClick={onCropSave}
            className={classes.cropButton}
            size="large"
            color="inherit"
          >
            <SaveIcon />
          </IconButton>
        </Tooltip>
      )}
    </Root>
  );
}
